import { toPersianNumber } from "@/hooks/useThousandsSeparator";
import { Link } from "react-router";

export const dataAccordion = [
  {
    id: 1,
    title: `آیا میتوان اعتبار ساعی پی را به صورت پول نقد دریافت کرد؟`,
    description: (
      <>
        خیر. اعتبارات دریافتی در سامانه ساعی پی تنها به صورت موجودی اعتباری در
        کیف پول اعتباری ساعی پی قرار دارد و تنها از طریق دستگاه های کارتخوان
        پذیرنده ساعی پی قابل استفاده میباشد.
      </>
    ),
  },
  {
    id: 2,
    title: `حداقل و حداکثر  زمان بازپرداخت اقساط به چه صورت میباشد؟`,
    description: (
      <>
        حداقل زمان بازپرداخت 1 ماه میباشد که در صورت پرداخت 1 ماهه هیچ گونه
        کارمزدی به اعتبار دریافت شده تعلق نخواهد گرفت. بیشترین زمان بازپرداخت
        اقساط در ساعی پی نیز 12 ماه میباشد.
      </>
    ),
  },
  {
    id: 3,
    title: `امکان برداشت از کیف پول و واریز به کارت شتابی را ندارم؟`,
    description: `برای انتقال وجه از کیف پول وامی پی به کارت های شتابی؛ در ابتدا باید کارت بانکی خود را در پنل کاربری خود ثبت نمایید. مورد دیگری که باید هنگام برداشت از کیف پول به آن توجه نمایید این است که شما امکان برداشت از کیف پول نقدی خود را دارید و اگر حساب نقدی شما کمتر از 25 هزار ریال باشد, امکان برداشت از کیف پول را نخواهید داشت.`,
  },
  {
    id: 4,
    title: "امکان انتقال وجه و کارت به کارت ندارم؟",
    description: `لطفا ابتدا از وصل نبودن فیلتر شکن خود مطمئن شوید و سپس اتصال به شبکه اینترنت را بررسی نمایید. توجه داشته باشید که انتقال وجه تنها  از کارت ساعی پی به کارت ساعی پی امکان پذیر میباشد. همچنین ممکن است در تنظیمات اکانت خود؛ مقدار مبلغ قابل برداشت در طول 24 ساعت را کاهش داده باشید.`,
  },
];
